import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
import {
  setStateParams,
  getPcpList,
} from "../../../Redux/Actions/webAppActions";
import PcpInputs from "./PcpInputs";
class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
      stateFlag: false,
      pcpShown: this.props.pcpSelected.pcpName
        ? this.props.pcpSelected.pcpName
        : "",
      clinicShown:
        this.props.pcpSelected.pcpName &&
        this.props.pcpSelected.pcpName !== "---Select---"
          ? this.props.physiciansData.length > 1
            ? this.props.physiciansData.filter(
                (data1) => data1.doctorName === this.props.pcpSelected.pcpName
              )[0] != undefined
              ? this.props.physiciansData.filter(
                  (data1) => data1.doctorName === this.props.pcpSelected.pcpName
                )[0].clinicName
              : ""
            : ""
          : this.props.preEnrollInfo && this.props.preEnrollInfo.pcpDetails
          ? this.props.preEnrollInfo.pcpDetails.name
          : "",
    };
    this.validator = new SimpleReactValidator();
  }

  async componentWillReceiveProps(nextProps) {
    const { planCategory } = nextProps.planCategory;
    if (planCategory === "GROUP") {
      await this.setState({ formerEmpOfSharp: true });
    }
  }
  componentDidMount() {
    var fullAddr = this.props.data.permanentAddrStreet
      ? this.props.data.permanentAddrStreet
      : "";
    const { data, permanentAddrStreet, permanentCity, permanentZip } =
      this.props;

    let zip = data.permanentZip;
    if (
      this.props.product != "PDP" &&
      this.props.productName !== "Medicare Supplement"
    ) {
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        zip !== "" &&
        this.props.deeplink === false
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          zip !== permanentZip
        ) {
          this.props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: zip,
            distance: "500",
            customerId: this.props?.customerId,
            planYear: this.props.year,
            productId:
              this.props.pendingApplFlag === false
                ? this.props.productId
                : this.props.preEnrollInfo.productId,
          });
          this.props.setStateParams(
            "permanentAddrStreet",
            data.permanentAddrStreet
          );
          this.props.setStateParams("permanentCity", data.permanentCity);
          this.props.setStateParams("permanentZip", zip);
          this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        this.props.dpzipCode !== "" &&
        this.props.deeplink === true
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          this.props.dpzipCode !== permanentZip
        ) {
          this.props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: this.props.dpzipCode,
            distance: "100",
            customerId: this.props?.customerId,
            planYear: this.props.year,
            productId:
              this.props.pendingApplFlag === false
                ? this.props.productId
                : this.props.preEnrollInfo.productId,
          });
          this.props.setStateParams(
            "permanentAddrStreet",
            data.permanentAddrStreet
          );
          this.props.setStateParams("permanentCity", data.permanentCity);
          this.props.setStateParams("permanentZip", this.props.dpzipCode);
          this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      // else {
      if (
        fullAddr === "" ||
        fullAddr === undefined ||
        data.permanentCity === ""
      ) {
        //   if(data.permanentAddrStreet === "" ||
        // data.permanentCity === ""){
        this.setState({ flag: true });
        this.props.setSnackBar(
          this.props.lang === "es"
            ? "Complete la dirección permanente en la sección 1 para obtener el PCP y el nombre de la clínica."
            : "Please fill permanent address in section 1 to get PCP's and Clinic Name."
        );
      }
    }
    // if (this.props.preEnrollInfo.pcpName) {
    //   console.log("working in if",this.props.preEnrollInfo)
    //    this.setState({
    //       ...this.state,
    //       pcpShown: "this.props.preEnrollInfo.pcpName",
    //     clinicShown: this.props.preEnrollInfo.pcpDetails?.name
    //       ? this.props.preEnrollInfo.pcpDetails?.name
    //       : "",
    //   });
    //   console.log("working after set state",this.state)
    // }
  }

  render() {
    const { data, planCategory } = this.props;
    return (
      <React.Fragment>
        {/* <div class="tab-content tab-contentSharp"> */}
        <div
          id="step1"
          class={
            this.props.preEnrollInfo?.appStatus != "READY" &&
            this.props.preEnrollInfo?.appStatus != "SUBMITTED"
              ? "container tab-pane active"
              : "container tab-pane active disable-form"
          }
        >
          <h3 class="tab-heading">
            <Text id="step2.Step2Sharp" /> – <Text id="step2.subStep" />
          </h3>
          <div class="form-panel">
            <p>
              <strong>
                A. <Text id="step2.A" />.
              </strong>
            </p>
            {planCategory === "INDIVIDUAL" ? (
              <>
                <div class="form-group">
                  <label class="control-label">
                    <Text id="step2.Quest23" />.
                  </label>
                  <div class="row">
                    <div class="col-sm">
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="ETHNICITY"
                          value="NA"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "NA" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label>
                          <Text id="step2.quesOP1" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          value="PR"
                          name="ETHNICITY"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "PR" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label>
                          <Text id="step2.quesOP2" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          value="OTH"
                          name="ETHNICITY"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "OTH" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label>
                          <Text id="step2.quesOP3" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          value="NR"
                          name="ETHNICITY"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "NR" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label>
                          <Text id="step2.quesOP4" />
                        </label>
                      </div>
                    </div>
                    <div class="col-sm">
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          id="MX"
                          value="MX"
                          name="ETHNICITY"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "MX" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label class="">
                          <Text id="step2.quesOP5" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          id="CUB"
                          name="ETHNICITY"
                          value="CUB"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "CUB" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label class="">
                          <Text id="step2.quesOP6" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">
                    <Text id="step2.ques24" />.
                  </label>
                  <div class="row">
                    <div class="col-sm" style={{ display: "grid" }}>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="300"
                          class="customCheckbox"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "300" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                        />
                        <label>
                          <Text id="step2.American" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="431"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "431" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Japanese" />
                        </label>
                      </div>

                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="451"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "451" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Vietnam" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="201"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "201" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Black" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="441"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "441" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Korean" />
                        </label>
                      </div>
                    </div>
                    <div class="col-sm" style={{ display: "grid" }}>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="499"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "499" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.OtherAsian" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="411"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "411" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label for="language">
                          <Text id="step2.Chinese" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="501"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "501" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.NativeHawaiian" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="599"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "599" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.OtherPaci" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="421"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "421" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Filipino" />
                        </label>
                      </div>
                    </div>
                    <div class="col-sm">
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="511"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "511" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Samoan" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="101"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "101" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.White" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="521"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "521" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.Guamanian" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="401"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "401" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.southAsian" />
                        </label>
                      </div>
                      <div>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          name="RACE"
                          value="999"
                          checked={data.ethnicityRace.some((item) =>
                            item.piValue === "999" ? true : false
                          )}
                          onChange={this.props.handleStepCheckbox}
                          class="customCheckbox"
                        />
                        <label>
                          <Text id="step2.notAns" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div class="form-group">
              <div style={{ display: "inline-flex" }}>
                <label for="language" class="control-label mr-2">
                  <Text id="step2.A1" />.
                </label>
                <div
                  class="custom-control custom-checkbox custom-control-inline"
                  // style={{ marginTop: "1rem" }}
                >
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    name="prefLng"
                    id="lfp_spanish"
                    class="custom-control-input"
                    value="SPA"
                    checked={data?.prefLng === "SPA"}
                    onChange={this.props.handleChange}
                  />
                  <label
                    for="lfp_spanish"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Spanish" />
                  </label>
                </div>
              </div>
              <fieldset class="radio radio-tab mt-3">
                <legend>
                  <Text id="step2.A2" />.
                </legend>
                <div class="custom-control custom-radio custom-control-inline mt-1">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="accessibleFormatVal"
                    id="lfp_braille"
                    class="custom-control-input"
                    value="B"
                    checked={data?.accessibleFormatVal === "B"}
                    onChange={this.props.handleChange}
                  />
                  <label
                    for="lfp_braille"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Ar1" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline mt-1">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="accessibleFormatVal"
                    id="lfp_largeprint"
                    class="custom-control-input"
                    value="L"
                    checked={data?.accessibleFormatVal === "L"}
                    onChange={this.props.handleChange}
                  />
                  <label
                    for="lfp_largeprint"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Ar2" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline mt-1">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="accessibleFormatVal"
                    id="lfp_other"
                    class="custom-control-input"
                    value="OTHER"
                    checked={
                      data?.accessibleFormatVal === "OTHER"
                      // ["",undefined].every((e1)=>e1!==document.getElementById("otherlanguageValue")?.value)
                    }
                    onChange={this.props.handleChange}
                  />
                  <label
                    for="lfp_other"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Ar3" />
                  </label>
                </div>
                <div
                  class="custom-control custom-control-inline mt-1"
                  // style={{ width: "500px" }}
                >
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    id="otherlanguageValue"
                    name="accessibleFormatOth"
                    value={data.accessibleFormatOth}
                    maxLength="10"
                    disabled={
                      data.accessibleFormatVal === "" ||
                      data.accessibleFormatVal === "B" ||
                      data.accessibleFormatVal === "L"
                    }
                    onChange={this.props.handleChange}
                    class={"form-control"}
                  />{" "}
                </div>
              </fieldset>
              <br />

              <>
                <Text id="step2.Para1Sharp" />
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="tel:1-855-562-8853"
                >
                  {" "}
                  1-855-562-8853{" "}
                </a>
                <Text id="step2.Para23" />
              </>
            </div>
            <div class="form-group">
              <p>
                <strong>
                  B. <Text id="step2.B" />
                </strong>
              </p>
              <p class="medicare-note">
                <Text id="step2.B1" /> &nbsp;
                <a
                  className="blueLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://sharpmedicareadvantage.com/findadoctor"
                >
                  <Text
                    id="step2.link2Sharp"
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                </a>
                &nbsp; <Text id="step2.B2" />.
              </p>

              <div class="row mt-3">
                <div class="col-md-4">
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="step2.currentpatient" />
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="isCurrentPatient"
                        id="currentPatient_Y"
                        class="custom-control-input"
                        value="Y"
                        checked={data.isCurrentPatient === "Y"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="currentPatient_Y"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="isCurrentPatient"
                        id="currentPatient_no"
                        class="custom-control-input"
                        value="N"
                        checked={data.isCurrentPatient === "N"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="currentPatient_no"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-4">
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="step2.Dowork" />
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="doYouWork"
                        id="dDoYouWork_Yes"
                        class="custom-control-input"
                        value="Y"
                        checked={data.doYouWork === "Y"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="dDoYouWork_Yes"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="doYouWork"
                        id="dDoYouWork_No"
                        class="custom-control-input"
                        value="N"
                        checked={data.doYouWork === "N"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="dDoYouWork_No"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-4">
                  <fieldset class="radio radio-tab mt-3">
                    <legend class="margin-left-0p5">
                      <Text id="step2.spousework" />
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="isSpouseWork"
                        id="dDoYourSpouseWork_Yes"
                        class="custom-control-input"
                        value="Y"
                        checked={data.isSpouseWork === "Y"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="dDoYourSpouseWork_Yes"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="isSpouseWork"
                        id="dDoYourSpouseWork_No"
                        class="custom-control-input"
                        value="N"
                        checked={data.isSpouseWork === "N"}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="dDoYourSpouseWork_No"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>

              <PcpInputs
                handleChange={this.props.handleChange}
                data={this.props.data}
              />

              <div class="mt-3">
                <label class="control-label" for="fileUpload">
                  <Text id="step4Agent.fileUpload" />
                </label>
                <div class="card">
                  <div className="card-header file-upload-container-aligner display-inline-flex">
                    <div class="select-file-typeSetp">
                      <label
                        class="control-label select-filetype-label-setp"
                        for="fileType"
                      >
                        <Text id="step4Agent.sfiletype" />
                      </label>
                      <select
                        name="fileType"
                        id="fileType"
                        class={"form-control"}
                        value={this.props.fileType}
                        onChange={this.props.handleChange}
                      >
                        {this.props.typeOfFilesToUpload.map((item, i) => {
                          return (
                            <option
                              class="select-option"
                              value={item.value}
                              key={i}
                            >
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="file-upload-aligner file-upload-container">
                      <label
                        className={
                          this.props.fileType === ""
                            ? "btn btn-secondary"
                            : "btn btn-primary"
                        }
                      >
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="file"
                          name="fileUpload"
                          id="fileUpload"
                          class="display-none"
                          onChange={this.props.handleChange}
                          onClick={(event) => (event.target.value = "")}
                          disabled={this.props.fileType === "" ? true : false}
                        />
                        <i className="fa fa-upload" aria-hidden="true"></i>
                        &nbsp;
                        <Text id="step4Agent.uploadFile" />
                      </label>
                    </div>
                    {/* <div>
                    <button
                      className="btn btn-danger"
                      onClick={this.props.clearFiles}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i>&nbsp;
                      <Text id="step4Agent.cancel" />
                    </button>
                  </div> */}
                  </div>
                  <div class="panel">
                    <div class="card-body">
                      {this.props.selectedFiles.map(
                        (file, index) =>
                          file.attachmentType !== "SIGNATURE" &&
                          file.attachmentType !== "ENROLLMENT" &&
                          file.attachmentType !== "SOA" && (
                            <div class="row">
                              <p class="col-md-3">
                                {file?.name || file?.attachmentType}
                              </p>
                              <a
                                href={this.props.url}
                                target="_blank"
                                class="col-md-5"
                                onClick={(e) =>
                                  this.props.viewFile(
                                    index,
                                    file.name || file.attachmentName, e
                                  )
                                }
                              >
                                {file?.File?.name || file?.attachmentName}
                              </a>
                              <p class="col-md-2">
                                {file && file.File
                                  ? `${file.File.size / 1024} kb`
                                  : ""}{" "}
                              </p>
                              <a
                                class="col-md-2 cursor-pointer"
                                onClick={() =>
                                  this.props.removeFile(
                                    index,
                                    file.name || file.attachmentName
                                  )
                                }
                              >
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12 mt-2">
                  <h4>
                    <Text id="step2.Para3" />
                  </h4>
                  <p>
                    <Text id="step2.Para4" />.
                    <strong>
                      <Text id="step2.Para5" />.
                    </strong>
                  </p>
                  <p>
                    <strong>
                      <Text id="step2.Para6" />.
                    </strong>
                    <Text id="step2.Para6" />.
                  </p>
                </div>
              </div>
            </div>
            {this.props.preEnrollInfo?.appStatus != "READY" &&
              this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                <button
                  class="btn btn-saveNext"
                  id="next2"
                  onClick={this.props.redirect}
                  style={{ backgroundColor: "#603167" }}
                >
                  <Text id="app.Save_Next" />
                </button>
              )}
          </div>
        </div>
        {/* </div> */}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    productId: state.login.productId,
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    physiciansData: state.webApp.physiciansData,
    pcpSelected: state.webApp.selectedVo,
    preEnrollInfo: state.webApp.preEnrollInfo,
    stateId: state.webApp.stateId,
    planType: state.webApp.planType,
    product: state.webApp.product,
    deeplink: state.login.deeplink,
    customerId: state.login.customerId,
    agentLogin: state.login.agentLoggedIn,
    lang: state.webApp.language,
    pendingApplFlag: state.webApp.pendingApplFlag,
  };
};
const mapDispatchToProps = {
  getPcpList,
  setStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(Step1);
